import "../css/TextBox.css";

const TextBox = ({ children, placeholder, disabled, setState, ...props }) => {
    return <input
        className="text-box"
        value={children}
        type="text"

        {...props}

        placeholder={placeholder}
        disabled={disabled}

        onChange={(e) => setState(e.target.value)}
    />
}

export default TextBox;